import "../../../resources/less/Family/ThemePages/CowboysAndAliens.less";
import BaseThematique from "./BaseThematique";

class CowboysAndAliens extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new CowboysAndAliens();
});
